module.exports = __webpack_public_path__ + "static/media/trusted-oberoi.b5e3a993.png";